"use client";

import { c as _c } from "react/compiler-runtime";
import MessagesLayout from "@/components/messages/layout/MessagesLayout";
import MessagesView from "@/components/messages/MessagesView";
export default function MessagesPageClient() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <MessagesLayout><MessagesView /></MessagesLayout>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}